import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María López',
    details: '34 años, Córdoba',
    text: 'Llegaba a casa sin energía para planificar. Con este kit, empecé marzo con todo listo. ¡No lo puedo creer!'
  }, {
    name: 'Carolina Fernández',
    details: '28 años, Buenos Aires',
    text: 'Soy maestra de 3° grado y este material me salvó. Las actividades son claras y los chicos las disfrutan.'
  }, {
    name: 'Lucía Martínez',
    details: '41 años, Rosario',
    text: 'Llevo 15 años dando clases y nunca tuve algo tan completo. Ojalá lo hubiera tenido antes.'
  }, {
    name: 'Ana García',
    details: '36 años, Mendoza',
    text: 'Lo mejor es que está organizado por grado y materia. No tengo que buscar más nada por separado.'
  }, {
    name: 'Valentina Rodríguez',
    details: '30 años, Tucumán',
    text: 'Mis compañeras me preguntaron cómo tenía todo tan organizado. Les pasé el link del kit.'
  }];
  return <section className="w-full bg-gray-50 py-10 px-4 md:px-8" data-id="element-180">
      <div className="max-w-6xl mx-auto" data-id="element-181">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-8" data-id="element-182">
          Lo que dicen otras maestras
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-183">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-5 rounded-xl shadow-sm border border-gray-100" data-id="element-184">
              <div className="flex gap-1 mb-3" data-id="element-185">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-186" />)}
              </div>
              <p className="text-gray-700 italic mb-4 text-base" data-id="element-187">"{t.text}"</p>
              <div className="mt-auto" data-id="element-188">
                <p className="font-bold text-gray-900" data-id="element-189">{t.name}</p>
                <p className="text-sm text-gray-500" data-id="element-190">{t.details}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}